module.exports = __webpack_public_path__ + "static/media/teamexileunknown.8585cdac.svg";